export const SafeUpIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
      fill="#18181B"
      stroke="#18181B"
      strokeWidth="1.5"
    ></path>
    <path
      d="M9 12l2 2 4-4"
      stroke="#CEFF3E"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
